/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryPeopleStateCounts = {
  /**
   * Profiles in the account_not_member state.
   */
  accountNotMember: number;
  /**
   * Profiles in the ambiguous_email state.
   */
  ambiguousEmail: number;
  /**
   * Profiles in the member state.
   */
  member: number;
  /**
   * Profiles in the not_signed_in state.
   */
  notSignedIn: number;
};

/** @internal */
export const DirectoryPeopleStateCounts$inboundSchema: z.ZodMiniType<
  DirectoryPeopleStateCounts,
  unknown
> = z.pipe(
  z.object({
    account_not_member: z.int(),
    ambiguous_email: z.int(),
    member: z.int(),
    not_signed_in: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "account_not_member": "accountNotMember",
      "ambiguous_email": "ambiguousEmail",
      "not_signed_in": "notSignedIn",
    });
  }),
);

export function directoryPeopleStateCountsFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryPeopleStateCounts, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryPeopleStateCounts$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryPeopleStateCounts' from JSON`,
  );
}
